import { render, staticRenderFns } from "./FileDownloadPost.vue?vue&type=template&id=1c5c904e&scoped=true"
import script from "./FileDownloadPost.vue?vue&type=script&lang=js"
export * from "./FileDownloadPost.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadPost.vue?vue&type=style&index=0&id=1c5c904e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5c904e",
  null
  
)

export default component.exports